import React, { useState } from 'react';
import queryString from 'query-string';
import { useLocation } from 'react-router-dom';

import BaseFilter, {
  FilterTypeEnum,
} from 'components/base/BaseFilter';
import {
  COUPON_REDEMPTION_METHOD,
} from 'config/CustomEnums';
import { ArrayStringData } from 'utils';

function Filter({ backAction = () => {} }) {
  const location = useLocation();

  const parsedSearch = queryString.parse(location.search);
  const searchOutOfStock = parsedSearch['out_of_stock'] || '';
  const searchStatus = parsedSearch['status'] || '';
  const searchExpired = parsedSearch['expired'] || '';

  const searchExpiredDateType = parsedSearch['expired_date'] || '';
  const searchExpiredDate = parsedSearch['absolute'] || '';
  const searchRelativeDay = parsedSearch['relativeDay'] || '';

  const searchRedemptionMethod = parsedSearch['redemption_method'] || '';

  const [outOfStock, setOutOfStock] = useState(searchOutOfStock);
  const [expiredDateType, setExpiredDateType] = useState(searchExpiredDateType);
  const [expiredDate, setExpiredDate] = useState(searchExpiredDate);
  const [status, setStatus] = useState(searchStatus);
  const [expired, setExpired] = useState(searchExpired);
  const [relativeDay, setRelativeDay] = useState(searchRelativeDay);
  const [offlineRedemptionMethod, setOfflineRedemptionMethod] = useState(
    ArrayStringData(searchRedemptionMethod),
  );

  const content = [
    {
      title: 'Out of stock',
      data: [
        { name: 'Out of stock', pk: 'true' },
        { name: 'Have stock', pk: 'false' },
      ],
      value: outOfStock,
      setValue: setOutOfStock,
      component: FilterTypeEnum.singleChoice,
      className: 'fit-content-height-area',
    },
    {
      title: 'Expired',
      data: [
        { name: 'Expired', pk: 'true' },
        { name: 'Unexpired', pk: 'false' },
      ],
      value: expired,
      setValue: setExpired,
      component: FilterTypeEnum.singleChoice,
      className: 'fit-content-height-area',
    },
    {
      title: 'Status',
      data: [
        { name: 'Active', pk: 'true' },
        { name: 'Inactive', pk: 'false' },
      ],
      value: status,
      setValue: setStatus,
      component: FilterTypeEnum.singleChoiceSegment,
    },
    {
      title: 'Expired date',
      data: [
        { name: 'All time', pk: 'allTime', subComponment: null },
        {
          name: 'Time Range',
          pk: 'absolute',
          subComponment: {
            value: expiredDate,
            setValue: setExpiredDate,
            component: FilterTypeEnum.dateRange,
          },
        },
        // {
        //   name: 'Since acquiring',
        //   pk: 'relativeDay',
        //   subComponment: {
        //     value: relativeDay,
        //     setValue: setRelativeDay,
        //     component: FilterTypeEnum.input,
        //   },
        // },
      ],
      value: expiredDateType,
      setValue: setExpiredDateType,
      component: FilterTypeEnum.singleChoice,
      className: 'fit-content-height-area',
    },
    {
      title: 'Redemption method',
      data: [
        {
          name: 'Merchant app scan Coupon QR code',
          pk: COUPON_REDEMPTION_METHOD.MERCHANT_APP_SCAN_COUPON_QR_CODE,
        },
        {
          name: 'Users scan Store QR code',
          pk: COUPON_REDEMPTION_METHOD.USERS_SCAN_STORE_QR_CODE,
        },
        {
          name: 'Merchant staff input store code only',
          pk: COUPON_REDEMPTION_METHOD.INPUT_STORE_STAFF_CODE,
        },
      ],
      value: offlineRedemptionMethod,
      setValue: setOfflineRedemptionMethod,
      component: FilterTypeEnum.choice,
      className: 'fit-content-height-area',
    },
  ];

  return <BaseFilter content={content} backAction={backAction} />;
}

export default Filter;
